function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="153" height="20" viewBox="0 0 153 20" {...props}><g fill="none" fillRule="evenodd" strokeWidth="3"><path stroke="#DDD" strokeLinecap="square" d="M10 10.5h136" /><circle cx="10" cy="10" r="8.5" fill="#FFF" stroke="#333" /><circle cx="77" cy="10" r="8.5" fill="#FFF" stroke="#DDD" /><circle cx="143" cy="10" r="8.5" fill="#FFF" stroke="#DDD" /></g></svg>;
});